import React from 'react';
interface LogoProps extends React.SVGProps<SVGSVGElement> {
  toolId: string;
}
export function ToolLogo({
  toolId,
  className,
  ...props
}: LogoProps) {
  const baseClass = `w-8 h-8 ${className || ''}`;
  switch (toolId) {
    case 'waydev':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-200">
          <path d="M6 8L11 24L16 14L21 24L26 8" className="stroke-indigo-500" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-201" />
          <circle cx="16" cy="8" r="2" className="fill-indigo-400" data-id="element-202" />
        </svg>;
    case 'dx':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-203">
          <circle cx="16" cy="16" r="12" className="stroke-indigo-500" strokeWidth="2" data-id="element-204" />
          <path d="M16 8L24 22H8L16 8Z" className="fill-indigo-400/80" data-id="element-205" />
        </svg>;
    case 'linearb':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-206">
          <rect x="6" y="8" width="20" height="4" rx="2" className="fill-indigo-500" data-id="element-207" />
          <rect x="6" y="20" width="14" height="4" rx="2" className="fill-indigo-400" data-id="element-208" />
          <circle cx="24" cy="22" r="3" className="fill-emerald-400" data-id="element-209" />
        </svg>;
    case 'jellyfish':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-210">
          <path d="M8 8C8 8 12 16 8 24M16 8C16 8 20 16 16 24M24 8C24 8 28 16 24 24" className="stroke-indigo-500" strokeWidth="3" strokeLinecap="round" data-id="element-211" />
        </svg>;
    case 'swarmia':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-212">
          <path d="M16 4L26.3923 10V22L16 28L5.6077 22V10L16 4Z" className="stroke-indigo-400" strokeWidth="2" data-id="element-213" />
          <circle cx="16" cy="16" r="4" className="fill-indigo-500" data-id="element-214" />
        </svg>;
    case 'sleuth':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-215">
          <rect x="16" y="4" width="16" height="16" transform="rotate(45 16 4)" className="stroke-indigo-500" strokeWidth="2" data-id="element-216" />
          <line x1="10" y1="22" x2="22" y2="10" className="stroke-indigo-400" strokeWidth="2" strokeLinecap="round" data-id="element-217" />
        </svg>;
    case 'harness':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-218">
          <rect x="6" y="6" width="6" height="20" rx="1" className="fill-indigo-500" data-id="element-219" />
          <rect x="20" y="6" width="6" height="20" rx="1" className="fill-indigo-500" data-id="element-220" />
          <rect x="12" y="14" width="8" height="4" className="fill-indigo-400" data-id="element-221" />
        </svg>;
    case 'codeclimate':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-222">
          <circle cx="12" cy="18" r="6" className="stroke-indigo-500" strokeWidth="2" data-id="element-223" />
          <circle cx="20" cy="18" r="6" className="stroke-indigo-500" strokeWidth="2" data-id="element-224" />
          <circle cx="16" cy="12" r="6" className="stroke-indigo-400" strokeWidth="2" data-id="element-225" />
        </svg>;
    case 'pluralsight':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-226">
          <path d="M8 6L26 16L8 26V6Z" className="stroke-indigo-500" strokeWidth="2" strokeLinejoin="round" data-id="element-227" />
          <path d="M12 11L20 16L12 21V11Z" className="fill-indigo-400" data-id="element-228" />
        </svg>;
    case 'uplevel':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-229">
          <path d="M8 22V12L16 6L24 12V22" className="stroke-indigo-500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-230" />
          <path d="M16 26V14" className="stroke-indigo-400" strokeWidth="2" strokeLinecap="round" data-id="element-231" />
        </svg>;
    case 'hatica':
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-232">
          <rect x="6" y="6" width="14" height="14" rx="2" className="stroke-indigo-500" strokeWidth="2" data-id="element-233" />
          <rect x="12" y="12" width="14" height="14" rx="2" className="stroke-indigo-400" strokeWidth="2" data-id="element-234" />
        </svg>;
    default:
      return <svg viewBox="0 0 32 32" fill="none" className={baseClass} {...props} data-id="element-235">
          <circle cx="16" cy="16" r="12" className="bg-slate-800" data-id="element-236" />
        </svg>;
  }
}